import { Component, inject, computed} from '@angular/core';
import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import {RevenueWidgetsService} from "../../../core/revenue/services/revenue-widget.service";

@Component({
  selector: 'app-revenue-widget',
  imports: [CurrencyPipe, DatePipe, DecimalPipe,  MatTooltipModule, RouterLink],
  templateUrl: './revenue-widget.component.html',
  styleUrl: './revenue-widget.component.scss'
})
export class RevenueWidgetComponent {
  private revenueWidgetService: RevenueWidgetsService = inject(RevenueWidgetsService);

  hasTargetRxPackets = computed(() => {
    return this.revenueWidgetService.hasTargetRxPackets();
  });

  revenueData = computed(() => {
    const kpis = this.revenueWidgetService.revenueKpis();

    return {
      total_revenue: kpis?.total_revenue,
      rx_packet_count: kpis?.rx_packet_count ?? 0,
      target_rx_packets: kpis?.target_rx_packets ?? 0,
      updated_at: kpis?.updated_at ?? '',
      currentMonth: this.revenueWidgetService.currentMonth()
    };
  });
}
